import { render } from "./RegistrationInfoSentEmail.vue?vue&type=template&id=4e0fe92c&scoped=true"
import script from "./RegistrationInfoSentEmail.vue?vue&type=script&lang=js"
export * from "./RegistrationInfoSentEmail.vue?vue&type=script&lang=js"

import "./RegistrationInfoSentEmail.vue?vue&type=style&index=0&id=4e0fe92c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0fe92c"]])

export default __exports__